var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.recommendList),function(item,index){return _c('div',{key:item.performanceId},[_c('RecommendItem',{attrs:{"content":item,"defaultColor":_vm.defaultColor[index % 7],"isRecommendABtest":_vm.isRecommendABtest}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }